<template>
    <BaseForm
        class="account-details"
        @submit="submitUserDetails"
    >
        <template #title>
            Vul je naam en adresgegevens in
        </template>

        <template #content>
            <FieldValidator
                v-slot="{ field, meta, errors, handleReset }"
                name="firstName"
            >
                <BaseFormField
                    :required="true"
                    :errors="errors"
                >
                    <template #label>Voornaam</template>
                    <BaseInput
                        v-bind="field"
                        type="text"
                        :validator="meta"
                        @clear="handleReset"
                    />
                </BaseFormField>
            </FieldValidator>

            <FieldValidator
                v-slot="{ field, meta, errors, handleReset }"
                name="lastName"
            >
                <BaseFormField
                    :required="true"
                    :errors="errors"
                >
                    <template #label>Achternaam</template>
                    <BaseInput
                        v-bind="field"
                        type="text"
                        :validator="meta"
                        @clear="handleReset"
                    />
                </BaseFormField>
            </FieldValidator>

            <FieldValidator
                v-slot="{ field, meta, errors, handleReset }"
                name="birthdate"
            >
                <BaseFormField
                    :required="true"
                    :errors="errors"
                >
                    <template #label>Geboortedatum</template>

                    <BaseInput
                        v-bind="field"
                        type="date"
                        :validator="meta"
                        @clear="handleReset"
                    />
                </BaseFormField>
            </FieldValidator>

            <FormFieldColumns
                data-columns-mobile="1"
                data-columns-desktop="1"
            >
                <FieldValidator
                    v-slot="{ field, meta, errors, handleReset }"
                    name="address"
                >
                    <BaseFormField
                        :required="true"
                        :errors="errors"
                    >
                        <template #label>Straatnaam en huisnummer</template>
                        <BaseInput
                            v-bind="field"
                            type="text"
                            :validator="meta"
                            @clear="handleReset"
                        />
                    </BaseFormField>
                </FieldValidator>
            </FormFieldColumns>

            <FormFieldColumns
                data-columns-mobile="2"
                data-columns-desktop="2"
            >
                <FieldValidator
                    v-slot="{ field, meta, errors, handleReset }"
                    name="zipCode"
                >
                    <BaseFormField
                        :required="true"
                        :errors="errors"
                    >
                        <template #label>Postcode</template>
                        <BaseInput
                            v-bind="field"
                            type="text"
                            :validator="meta"
                            @clear="handleReset"
                        />
                    </BaseFormField>
                </FieldValidator>

                <FieldValidator
                    v-slot="{ field, meta, errors, handleReset }"
                    name="city"
                >
                    <BaseFormField
                        :required="true"
                        :errors="errors"
                    >
                        <template #label>Plaats</template>
                        <BaseInput
                            v-bind="field"
                            type="text"
                            :validator="meta"
                            @clear="handleReset"
                        />
                    </BaseFormField>
                </FieldValidator>
            </FormFieldColumns>
        </template>

        <template #actions>
            <BaseButton
                type="submit"
                class="form__submit button--secondary form__button--max-width"
            >
                Volgende stap
            </BaseButton>
        </template>
    </BaseForm>
</template>

<script setup lang="ts">
import { useForm, Field as FieldValidator } from 'vee-validate';

const emit = defineEmits(['submit']);

interface UserDetailsForm {
    firstName: string;
    lastName: string;
    birthdate: string;
    zipCode: string;
    address: string;
    city: string;
}

const userStore = useUserStore();

const { user } = storeToRefs(userStore);

const { handleSubmit } = useForm<UserDetailsForm>({
    validationSchema: {
        firstName: 'required',
        lastName: 'required',
        birthdate: 'required',
        zipCode: 'required|zipCode',
        address: 'required',
        city: 'required',
    },
    initialValues: {
        firstName: user.value?.first_name ?? '',
        lastName: user.value?.last_name ?? '',
        birthdate: user.value?.birthdate ?? '',
        zipCode: user.value?.zip ?? '',
        address: user.value?.address ?? '',
        city: user.value?.city ?? '',
    },
});

const submitUserDetails = handleSubmit((formData) => {
    emit('submit', {
        firstName: formData.firstName,
        lastName: formData.lastName,
        birthdate: formData.birthdate,
        zip: formData.zipCode,
        address: formData.address,
        city: formData.city,
    });
});
</script>

<style lang="less" src="./FormUserDetails.less" />
